
import localizationEn from './en-en.js';

export default {
    'en-en': localizationEn,
};
